<template>
  <div v-bind:class="['ssws-item-section']">
    <a
      class="iteml-section"
      :href="item.permalink"
      :target="target == 'blank' ? '_blank' : ''"
      :aria-labelledby="'heading-level_' + item.post_date"
    >
      <div class="left-sec">
        <div
          class="ssws_is-new"
          v-if="
            item.metadata['ssws_ledig-plats-text'] &&
            item.metadata['ssws_ledig-plats']
          "
        >
          <span> {{ item.metadata['ssws_ledig-plats-text'] }}</span>
        </div>
        <div class="img-sec">
          <div
            class="single-is-newly-opened"
            v-if="item.metadata['ssws_is-new'] == true"
          >
            {{ item.metadata['ssws_date-of-opening'] }}
          </div>
          <div
            class="single-is-newly-opened"
            v-if="checkifNewOpen(item.metadata['ssws_newly-opened'])"
          >
            Nyöppnat
          </div>
          <div v-if="item.images.medium">
            <a :href="item.permalink" target="_blank" v-if="target == 'blank'">
              <img :src="item.images.medium.url" :alt="item.post_title" />
            </a>
            <a :href="item.permalink" v-else>
              <img :src="item.images.medium.url" :alt="item.post_title" />
            </a>
          </div>
        </div>
        <div
          class="location-sec"
          v-if="item.metadata && item.metadata.ssws_adress"
        >
          <span class="map-locator">
            <svg
              enable-background="new 0 0 362.3 362.3"
              version="1.1"
              viewBox="0 0 362.3 362.3"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="m181.15 0c-76.855 0-139.38 62.528-139.38 139.38 0 72.646 115.69 197.71 128.88 211.75l10.502 11.163 10.502-11.163c13.193-14.027 128.88-139.11 128.88-211.75 6e-3 -76.856-62.522-139.38-139.38-139.38zm0 197.06c-31.801 0-57.676-25.875-57.676-57.676 0-31.802 25.875-57.676 57.676-57.676 31.808 0 57.676 25.875 57.676 57.676 0 31.802-25.868 57.676-57.676 57.676z"
              />
            </svg>
          </span>

          <div id="location">
            <p class="categ" v-if="item.taxonomies['Kommune']">
              <span
                class="item"
                v-for="(Kommune, idx) in item.taxonomies['Kommune']"
                :key="idx"
              >
                {{ Kommune
                }}<span v-if="idx + 1 < item.taxonomies['Kommune'].length"
                  >,
                </span>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="content-sec">
        <p class="categ" v-if="item.taxonomies['Tilbud']">
          <span
            class="item"
            v-for="(tilbud, idx) in item.taxonomies['Tilbud']"
            :key="idx"
          >
            {{ tilbud
            }}<span v-if="idx + 1 < item.taxonomies['Tilbud'].length">, </span>
          </span>
        </p>

        <h3 class="item-title h3style" :id="'heading-level_' + item.post_date">
          <ais-highlight :hit="item" attribute="post_title" />
        </h3>

        <p class="plaster" v-if="item.metadata['ssws_antal-platser']">
          <strong>{{ copy.numOfSeats }}: </strong>
          {{ item.metadata['ssws_antal-platser'] }}
        </p>
        <p class="group" v-if="item.taxonomies.Målgruppe">
          <strong>{{ copy.targetGroup }}: </strong>
          <span
            class="item"
            v-for="(Målgruppe, idx) in item.taxonomies['Målgruppe']"
            :key="idx"
          >
            <span v-html="Målgruppe"></span>
            <span v-if="idx + 1 < item.taxonomies['Målgruppe'].length">, </span>
          </span>
        </p>

        <p class="group" v-if="item.taxonomies.Godkendelsesparagraf">
          <strong>Paragraffer: </strong>
          <span
            class="item"
            v-for="(Godkendelsesparagraf, idx) in item.taxonomies[
              'Godkendelsesparagraf'
            ]"
            :key="idx"
          >
            <span v-html="Godkendelsesparagraf"></span>
            <span
              v-if="idx + 1 < item.taxonomies['Godkendelsesparagraf'].length"
              >,
            </span>
          </span>
        </p>

        <p class="group" v-if="item.metadata.Ledigplads">
          <strong>Ledig plads: </strong>
          <span
            class="item"
            v-for="(Ledigplads, idx) in item.metadata['ssws_ledig-plats']"
            :key="idx"
          >
            <span v-html="Ledigplads"></span>
            <span v-if="idx + 1 < item.metadata['Ledigplads'].length">, </span>
          </span>
        </p>

        <p class="person-kit" v-if="item.taxonomies['Aldersgruppe']">
          <strong>{{ copy.aldersgruppe }}: </strong>
          <span
            class="item"
            v-for="(Personkrets, idx) in item.taxonomies['Aldersgruppe']"
            :key="idx"
          >
            {{ Personkrets
            }}<span v-if="idx + 1 < item.taxonomies['Aldersgruppe'].length"
              >,
            </span>
          </span>
        </p>

        <p
          class="content"
          v-html="
            item.post_excerpt
              ? item.post_excerpt
              : getSentences(item.content, 2, 200, ' ...')
          "
        ></p>

        <p class="address" v-if="item.metadata['ssws_age-span']">
          <strong>{{ copy.ageRange }}: </strong>
          {{ item.metadata['ssws_age-span'] }}
        </p>
        <p class="diagnoses" v-if="item.taxonomies['Diagnos/specialiteter']">
          <strong>{{ copy.diagnosTitle }}: </strong>
          <span
            class="item"
            v-for="(Diagnos, idx) in item.taxonomies['Diagnos/specialiteter']"
            :key="idx"
          >
            {{ Diagnos
            }}<span
              v-if="idx + 1 < item.taxonomies['Diagnos/specialiteter'].length"
              >,
            </span>
          </span>
        </p>
        <p class="lagrum" v-if="item.taxonomies['Lagrum']">
          <strong>{{ copy.storageSpace }}: </strong>
          <span
            class="item"
            v-for="(Lagrum, idx) in item.taxonomies['Lagrum']"
            :key="idx"
          >
            {{ Lagrum
            }}<span v-if="idx + 1 < item.taxonomies['Lagrum'].length">, </span>
          </span>
        </p>
        <p class="read-more">
          {{ copy.laes_mere }}
        </p>
      </div>
    </a>
    <div class="right-sec">
      <span class="the-chef" v-if="item.metadata['ssws_ec-namn']">
        <span v-if="item.metadata['ssws_ec-alternative-title']">
          {{ item.metadata['ssws_ec-alternative-title'].toLowerCase() }}
        </span>
        <span v-else> {{ copy.itemLeder.toLowerCase() }} </span>
        <span class="right-title"> {{ item.metadata['ssws_ec-namn'] }} </span>
      </span>
      <div class="info-sec">
        <p class="tel" v-if="item.metadata['ssws_ec-tel']">
          {{ copy.telTitle }}:
          <span class="text-green"
            ><a :href="`tel:${item.metadata['ssws_ec-tel']}`">{{
              item.metadata['ssws_ec-tel']
            }}</a></span
          >
        </p>
        <p class="e-post" v-if="item.metadata['ssws_ec-mail']">
          {{ copy.mailTitle }}:
          <span class="text-green"
            ><a :href="`mailto:${item.metadata['ssws_ec-mail']}`">{{
              item.metadata['ssws_ec-mail']
            }}</a></span
          >
        </p>
        <p class="phone2" v-if="item.metadata['ssws_ec-phone']">
          <span v-if="item.metadata['ssws_ec-phone_label']">{{
            item.metadata['ssws_ec-phone_label']
          }}</span>
          <span v-else> Hustelefon (døgnåbent):</span>
          <span class="text-green">
            <a :href="`tel:${item.metadata['ssws_ec-phone']}`">{{
              item.metadata['ssws_ec-phone']
            }}</a></span
          >
        </p>
      </div>
      <span class="address" v-if="item.metadata.ssws_adress">
        <span class="address-title">{{ copy.visiting_Adresse }}</span>
        <span>
          {{ item.metadata.ssws_adress }}
        </span>

        <br />
        <span v-if="item.metadata.ssws_postnr">
          {{ item.metadata.ssws_postnr }}
        </span>
        <span v-if="item.metadata.ssws_ort">
          {{ item.metadata.ssws_ort }}
        </span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    item: Object,
    copy: Object,
    target: String,
    index: Number,
  },
  methods: {
    checkifNewOpen(respuesta1) {
      if (respuesta1) {
        const newct = JSON.parse(JSON.stringify(respuesta1));
        var result = newct[Object.keys(newct)[0]];
        return result == '1' ? true : false;
      } else {
        return false;
      }
    },
    getSentences(content, nOfSentences, limit, suffix) {
      // eslint-disable-next-line
      let contentArray = content.match(/[^\.!\?]+[\.!\?]+/g);
      var firstN = contentArray.slice(0, nOfSentences).join('');

      if (firstN.length <= limit) {
        return firstN;
      }

      firstN = firstN.substring(0, limit);
      let lastSpaceIndex = firstN.lastIndexOf(' ');
      firstN = firstN.substring(0, lastSpaceIndex);

      if (suffix) {
        firstN += suffix;
      }

      return firstN;
    },
    computeAddressString(addressObj) {
      var address = '';

      if (
        typeof addressObj.street !== 'undefined' &&
        addressObj.street !== ''
      ) {
        address += addressObj.street + '<br>';
      }

      if (typeof addressObj.zip !== 'undefined' && addressObj.zip !== '') {
        let addzip = addressObj.zip;
        let addzipspaced = addzip.match(/.{1,3}/g);
        let zip_with_space = addzipspaced.join(' ');
        address += zip_with_space + ' ';
      }

      if (address !== '') {
        if (typeof addressObj.city !== 'undefined' && addressObj.city !== '') {
          address += addressObj.city + ' ';
        }
        return address.trim();
      }

      if (typeof addressObj.city !== 'undefined' && addressObj.city !== '') {
        return addressObj.city.trim();
      }

      if (
        typeof addressObj.municipality !== 'undefined' &&
        addressObj.municipality !== ''
      ) {
        return addressObj.municipality.trim();
      }

      if (
        typeof addressObj.region !== 'undefined' &&
        addressObj.region !== ''
      ) {
        return addressObj.region.trim();
      }

      return '';
    },
    computeLocation(address) {
      var location = '';

      if (typeof address.city !== 'undefined' && address.city !== '') {
        location += address.city;
      }

      if (
        typeof address.municipality !== 'undefined' &&
        address.municipality !== ''
      ) {
        if (
          location !== '' &&
          location.trim().toUpperCase() !==
            address.municipality.trim().toUpperCase()
        ) {
          location += ', ' + address.municipality;
        } else {
          location = address.municipality;
        }
      }

      if (typeof address.region !== 'undefined' && address.region !== '') {
        if (location === '') {
          return address.region;
        } else {
          var municipality = '';
          if (typeof address.municipality !== 'undefined') {
            municipality = address.municipality;
          }

          if (
            address.region.trim().toUpperCase() !==
            municipality.trim().toUpperCase()
          ) {
            location += ', ' + address.region;
          } else {
            return location;
          }
        }
      }

      return location;
    },
  },
};
</script>
<style>
p.phone2 span.text-green {
  display: block;
}
a.remove_underline {
  text-decoration: none !important;
  color: #000 !important;
}
.ssws-item-section .left-sec {
  padding: 30px;
  width: 25%;
  max-width: 220px;
}
.ssws-item-section .content-sec {
  width: 50%;
  padding: 30px;
}

.ssws-item-section {
  display: flex;
  margin-bottom: 1rem;
  border: 1px solid #c4c8d8;
  box-shadow: 0 2px 5px 0 #e3e5ec;
}

.ssws-item-section.hidden {
  display: none;
}

.ssws-item-section .img-sec img {
  height: 150px;
  width: 150px;
  object-fit: cover;
}

.ssws-item-section .search-more-item-wrap .hidden {
  display: none !important;
}

.ssws-item-section span.map-locator {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.ssws-item-section .location-sec {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.h3style {
  display: block;
  font-size: 1.5em;
  margin-top: 0.83em;
  margin-bottom: 10px;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
  padding-bottom: 10px;
}

.search-panel__results .ais-InfiniteHits-item a.iteml-section {
  position: relative;
}
.search-panel__results .ais-InfiniteHits-item a.iteml-section:focus-visible {
  outline: 3px solid #02857d !important;
}
.ssws-item-section .left-sec {
  position: relative;
  z-index: 0;
}
.ssws-item-section .left-sec .ssws_is-new {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px;
  z-index: 1;
  background: #b8460f !important;
  color: #fff;
}

.single-is-newly-opened {
  background-color: #b8460f;
}

@media (max-width: 991px) {
  .ssws-item-section .left-sec,
  .ssws-item-section .content-sec {
    width: 50%;
    max-width: 100%;
  }
  .ssws-item-section .right-sec {
    display: none;
  }
  .ssws-item-section .img-sec img {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 767px) {
  .ssws-item-section .left-sec,
  .ssws-item-section .content-sec {
    width: 100%;
  }
  .ssws-item-section .ssws-item-section {
    flex-direction: column;
  }
}
</style>
